import { Component, OnInit } from '@angular/core';
import { GaEventService } from '../shared/services/ga-event.service';
import { EVENT_UPDATE_MAIN_URL } from '../shared/app-events';
import { StateService, UiOnParamsChanged } from '@uirouter/angular';

@Component({
  selector: 'main-params',
  template: ''
})
export class MainParamsComponent implements OnInit, UiOnParamsChanged {
  constructor(
    private eventService:GaEventService,
    private stateService:StateService
  ) {
    /**/
  }

  public ngOnInit():void {
    this.notifyUrlChange();
  }

  public uiOnParamsChanged():void {
    this.notifyUrlChange();
  }

  private notifyUrlChange():void {
    this.eventService.sendMessage(EVENT_UPDATE_MAIN_URL, this.stateService.params.url);
  }
}